<template>
  <div class="row spinner-parent menu-edit-wrapper">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h1>{{ source.name }}</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Name</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="menuName"
                      type="text"
                      placeholder="Enter menu name"
                      class="form-control"
                      disabled
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>Builder</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div v-if="orderChanged" class="alert alert-warning">
                  Items order changed. Don't forget to save it!
                </div>

                <div class="menu-builder">
                  <div class="menu-builder__btns">
                    <button class="btn btn-primary" @click="addItemToTop">Add item</button>
                  </div>

                  <div class="menu-builder-item-template" style="display: none">
                    <li class="menu-builder__item-wrap" data-id="">
                      <div class="menu-builder__item">
                        <div class="menu-builder__item-inner">
                          <div class="menu-builder__item-img">
                            <img src="" alt="">
                          </div>
                          <div class="menu-builder__item-data">
                            <div class="menu-builder__item-data-row _id">
                              <b>ID:</b> <span />
                            </div>
                            <div class="menu-builder__item-data-row _title">
                              <b>Title:</b> <span />
                            </div>
                            <div class="menu-builder__item-data-row _url">
                              <b>Url:</b> <span />
                            </div>
                          </div>
                          <div class="menu-builder__item-btns">
                            <button class="btn btn-primary btn-add">Add item</button>
                            <button class="btn btn-primary btn-edit">Edit</button>
                            <button class="btn btn-warning btn-open">Open</button>
                            <button class="btn btn-danger btn-delete">Delete</button>
                          </div>
                        </div>
                      </div>
                    </li>
                  </div>

                  <div class="menu-builder-inner">
                    <ul>
                      <menu-item
                        v-for="item in menuTree"
                        :key="item.id"
                        :content="item"
                      />
                    </ul>
                  </div>

                  <div v-if="menuTree.length > 5" class="menu-builder__btns">
                    <button class="btn btn-primary" @click="addItemToBottom">Add item</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success save-menu" @click="saveAll">Save</button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">Data saved successful!</div>
          <div class="alert alert-danger" style="display: none;">{{ saveErrorMessage }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import '@/global/libs/jquery-sortable-lists';
import 'bootstrap';

export default {
  name: 'MenuEdit',

  data() {
    return {
      source: null,
      menuName: null,
      menuTree: [],
      menuArray: [],
      saveErrorMessage: 'Error in data saving',
      orderChanged: false,
    };
  },

  mounted() {
    const self = this;
    this.getSource();

    $(document).on('click', '.menu-builder__item.has-child .menu-builder__item-btns .btn', (e) => {
      e.stopPropagation();
    });
    $(document).on('click', '.menu-builder__item-btns .btn-delete', function () {
      if (window.confirm('Do you really want to delete this menu item?')) {
        $(this).append('<span class="btn-loader"></span>');
        self.deleteItem($(this).closest('.menu-builder__item-wrap').data('id'));
      }
    });
    $(document).on('click', '.menu-builder__item-btns .btn-edit', function () {
      const menuItemId = $(this).closest('.menu-builder__item-wrap').data('id');
      const itemIndex = _.findIndex(self.menuArray, item => item.id === menuItemId);
      self.editItemPopup(self.menuArray[itemIndex]);
    });
    $(document).on('click', '.menu-builder__item-btns .btn-add', function () {
      const menuItemId = $(this).closest('.menu-builder__item-wrap').data('id');
      self.addItemInside(menuItemId);
    });
    $(document).on('click', '.menu-builder__item-btns .btn-open', function () {
      const menuItemId = $(this).closest('.menu-builder__item-wrap').data('id');
      window.open(`${self.$config.app_api.host}menu-item/${menuItemId}`, '_blank');
    });
    this.$root.$on('menuItemSaveNewSuccess', (newContent, spot) => {
      const newItem = $('.menu-builder-item-template .menu-builder__item-wrap').clone();
      newItem.data('id', newContent.id);
      newItem.find('.menu-builder__item-img img').attr('src', newContent.image ? newContent.image.public_url : '');
      newItem.find('.menu-builder__item-data-row._id span').text(newContent.id);
      newItem.find('.menu-builder__item-data-row._title span').text(newContent.title);
      newItem.find('.menu-builder__item-data-row._url span').text(newContent.url);
      const $parentItem = $(`.menu-builder__item-wrap[data-id="${newContent.parent_id}"]`);
      if (newContent.parent_id !== 0) {
        if ($parentItem.children('ul').length === 0) {
          this.createDomForList($parentItem);
        }
        $parentItem.children('ul').append(newItem);
      } else if (spot === 'top') {
        $('.menu-builder-inner > ul').prepend(newItem);
      } else {
        $('.menu-builder-inner > ul').append(newItem);
      }

      this.menuArray.push(newContent);
      this.orderChanged = true;
    });
    this.$root.$on('menuItemSaveExistingSuccess', (item) => {
      const menuItem = this.menuArray.find(arrayItem => arrayItem.id === item.id);
      if (!menuItem) {
        return;
      }
      menuItem.id = item.id;
      menuItem.parent_id = item.parent_id;
      menuItem.order = item.order;
      menuItem.title = item.title;
      menuItem.url = item.url;
      menuItem.tooltip = item.tooltip;
      menuItem.route = item.route;
      menuItem.parameters = item.parameters;
      menuItem.image = item.image;
      menuItem.target = item.target;
      menuItem.path_alias = item.path_alias;
      menuItem.hidden = item.hidden;
      this.menuTree = this.listToTree(_.cloneDeep(this.menuArray));
    });
  },

  destroyed() {
    $(document).off('click', '.menu-builder__item.has-child .menu-builder__item-btns .btn');
    $(document).off('click', '.menu-builder__item-btns .btn-delete');
    $(document).off('click', '.menu-builder__item-btns .btn-edit');
    $(document).off('click', '.menu-builder__item-btns .btn-add');
    $(document).off('click', '.menu-builder__item-btns .btn-open');
    this.$root.$off('menuItemSaveNewSuccess');
    this.$root.$off('menuItemSaveExistingSuccess');
    $('#sortableListsBase').remove();
  },

  methods: {
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}menu/${this.$route.params.id}?with[]=image&with[]=path_alias`)
        .then((response) => {
          this.source = response.data;
          this.menuName = response.data.name;
          this.menuArray = _.cloneDeep(response.data.items);
          this.menuTree = this.listToTree(_.cloneDeep(response.data.items));

          if (this.$refs.spinner) { this.$refs.spinner.hide(); }

          setTimeout(() => {
            this.initSortableList();
          }, 300);
        })
        .catch((error) => {
          console.error(error);
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting data request' });
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        });
    },
    listToTree(list) {
      const map = {};
      const roots = [];
      let node;
      let i;
      for (i = 0; i < list.length; i += 1) {
        map[list[i].id] = i; // initialize the map
        // eslint-disable-next-line
        list[i].children = []; // initialize the children
      }
      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parent_id !== 0) {
          // if you have dangling branches check that map[node.parent_id] exists
          list[map[node.parent_id]].children.push(node);
        } else {
          roots.push(node);
        }
      }
      return roots;
    },
    initSortableList() {
      const self = this;
      const options = {
        placeholderClass: 'menu-builder__item-placeholder',
        hintClass: 'menu-builder__item-hint',
        ignoreClass: 'btn',
        opener: {
          active: true,
          as: 'html',
          close: '<i class="fa fa-minus"></i>',
          open: '<i class="fa fa-plus"></i>',
          openerClass: 'menu-builder__item-opener',
        },
        onChange(cEl) {
          const elementId = cEl.data('id');
          const $parentEl = cEl.parent('ul').parent();
          let parentElId = 0;
          const itemIndex = _.findIndex(self.menuArray, item => item.id === elementId);
          if (!$parentEl.hasClass('menu-builder-inner')) {
            parentElId = $parentEl.data('id');
          }
          self.menuArray[itemIndex].parent_id = parentElId;
          $parentEl.children('ul').children('li').each(function (index) {
            const liId = $(this).data('id');
            const liIndex = _.findIndex(self.menuArray, item => item.id === liId);
            self.menuArray[liIndex].order = index;
          });
          this.orderChanged = true;
        },
      };
      $('.menu-builder-inner > ul').sortableLists(options);
    },
    createDomForList($parentItem) {
      $parentItem.append('<ul></ul>');
      $parentItem.children('.menu-builder__item')
        .prepend('<span class="sortableListsOpener menu-builder__item-opener"><i class="fa fa-minus"></i></span>');
      $parentItem.find('.sortableListsOpener').on('mousedown', function () {
        const li = $(this).closest('li');
        if (li.hasClass('sortableListsClosed')) {
          li.children('ul').show();
          li.addClass('sortableListsOpen').removeClass('sortableListsClosed');
          li.children('.menu-builder__item')
            .children('.menu-builder__item-opener')
            .html('<i class="fa fa-minus"></i>');
        } else {
          li.children('ul').hide();
          li.addClass('sortableListsClosed').removeClass('sortableListsOpen');
          li.children('.menu-builder__item')
            .children('.menu-builder__item-opener')
            .html('<i class="fa fa-plus"></i>');
        }
        return false;
      });
    },
    addItemToTop() {
      const itemsInParent = _.filter(this.menuArray, item => item.parent_id === 0);
      const minOrderObj = _.minBy(itemsInParent, item => item.order);
      this.newItemPopup(0, minOrderObj ? minOrderObj.order - 1 : 0, 'top');
    },
    addItemToBottom() {
      const itemsInParent = _.filter(this.menuArray, item => item.parent_id === 0);
      const maxOrderObj = _.maxBy(itemsInParent, item => item.order);
      this.newItemPopup(0, maxOrderObj ? maxOrderObj.order + 1 : 0, 'bottom');
    },
    addItemInside(parentId) {
      const itemsInParent = _.filter(this.menuArray, item => item.parent_id === parentId);
      const maxOrderObj = _.maxBy(itemsInParent, item => item.order);
      this.newItemPopup(parentId, maxOrderObj ? maxOrderObj.order + 1 : 0, 'bottom');
    },
    editItemPopup(content) {
      this.$root.$emit('menuItemSetParams', content, 'edit');
    },
    newItemPopup(parentId, order, spot) {
      const content = {
        menu_id: this.$route.params.id,
        parent_id: parentId,
        order,
        spot,
      };
      this.$root.$emit('menuItemSetParams', content, 'new');
    },
    saveAll() {
      let updateMenuItemsComplete = false;
      $('.saving-alerts .alert').hide();
      $('.btn-success.save-menu').append('<span class="btn-loader"></span>');
      this.$apiHttp.post(`${this.$config.app_api.prefix}menu/${this.$route.params.id}/menu-items/bulk-update`, {
        items: this.menuArray,
      }, {
        headers: {
          'content-type': 'application/json',
        },
      }).then(() => {
        updateMenuItemsComplete = true;
        if (updateMenuItemsComplete) {
          $('.btn-success.save-menu .btn-loader').remove();
          $('.saving-alerts .alert-success').show();
        }
      }).catch((error) => {
        updateMenuItemsComplete = true;
        console.error(error);
        if (updateMenuItemsComplete) {
          $('.btn-success.save-menu .btn-loader').remove();
          $('.saving-alerts .alert-danger').show();
        }
      });
    },
    deleteItem(itemId) {
      this.$apiHttp.delete(`${this.$config.app_api.prefix}menu/${this.$route.params.id}/menu-items/${itemId}`)
        .then(() => {
          const arrayRemove = [];
          arrayRemove.push(itemId);
          $(`.menu-builder__item-wrap[data-id="${itemId}"]`).find('.menu-builder__item-wrap').each(function () {
            arrayRemove.push($(this).data('id'));
          });
          _.remove(this.menuArray, (item) => {
            for (let i = 0; i < arrayRemove.length; i += 1) {
              if (arrayRemove[i] === item.id) {
                return true;
              }
            }
            return false;
          });
          $(`.menu-builder__item-wrap[data-id="${itemId}"]`).remove();
          this.$store.commit('notifications/setSuccessNotification', 'Deleted.');
        })
        .catch((error) => {
          $(`.menu-builder__item-wrap[data-id="${itemId}"] .btn-delete .btn-loader`).remove();
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in deleting menu item request' });
          console.error('Error in deleteMenu mutation, ', error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?73a2e673